/**
 * CURRENT VERSION: v8034
 *
 * Add, commit, and push in one command like this: git add . && git commit -m "vXXX Detailed message" && git push branch-name
 * Version above +1 is manually added to the start of every commit message
 *
 * Version is managed by pre-commit hook and automatically updated (do not edit!)
 * Never add version numbers to debug logs or comments

 */

export const VERSION = 'v8034';

// Export a function to get the version
export const getVersion = () => VERSION;

// Export a function to get the version number (without the 'v')
export const getVersionNumber = () => parseInt(VERSION.substring(1), 10);
